import React, { Component } from 'react';
import voca from 'voca';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';

export class ExternalApiError extends Component {
  state = {
    errorPath: this.props.error.path,
    errorValue: this.props.error.value,
    errorMsg: this.props.error.message,
  };

  onPathChange = (e) => {
    this.setState({
      ...this.state,
      errorPath: voca.trim(e.target.value),
    });

    this.props.error.path = voca.trim(e.target.value);
    this.props.createNewErrorRow(this.props.error);
  };

  onValueChange = (e) => {
    this.setState({
      ...this.state,
      errorValue: e.target.value,
    });
    this.props.error.value = e.target.value;
    this.props.createNewErrorRow(this.props.error);
  };

  onMessageChange = (e) => {
    this.setState({
      ...this.state,
      errorMsg: e.target.value,
    });
    this.props.error.message = e.target.value;
    this.props.createNewErrorRow(this.props.error);
  };

  render() {
    console.log('this.props.error', this.props.error);
    return (
      <div className="row">
        <div className="col-md-1">{this.props.error.id}.</div>
        <div className="col-md-11">
          <div className="row">
            <div className="col-md-4">
              <CustomInputWithIcon icon="text" title="JSON path of error field">
                <input
                  name="errorPath"
                  onChange={this.onPathChange}
                  value={this.state.errorPath}
                  className="form-control form-control-sm"
                  placeholder="JSON path of error field"
                  title="JSON path of error field"
                  required={true}
                />
              </CustomInputWithIcon>
            </div>
            <label className="col-md-2 text-muted mt-2 w-50">is equals to</label>
            <div className="col-md-4 ">
              <CustomInputWithIcon icon="text" title="Error field value">
                <input
                  name="errorValue"
                  onChange={this.onValueChange}
                  value={this.state.errorValue}
                  className="form-control form-control-sm"
                  placeholder="Error field value"
                  title="Error field value"
                />
              </CustomInputWithIcon>
            </div>
            <label className="col-md-2 text-muted mt-2">then it's an error</label>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12">
              <CustomInputWithIcon icon="text" title="JSON path of error message field">
                <input
                  name="errorMsg"
                  onChange={this.onMessageChange}
                  value={this.state.errorMsg}
                  className="form-control form-control-sm mr-2"
                  placeholder="JSON path of error message field"
                  title="JSON path of error message field"
                />
              </CustomInputWithIcon>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ExternalApiError;
